import { useState } from "react";
import { api, ApiError } from "../api/client.js";
import { OAuthButtons } from "./OAuthButtons.jsx";

export function LoginForm({ audience, onSuccess, onForgotPassword, onGoToSignup }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post(`/api/${audience}/auth/login`, { email, password });
      onSuccess();
    } catch (err) {
      if (err instanceof ApiError && err.body?.code === "email_not_verified") {
        setError("Prašome patvirtinti savo el. paštą prieš prisijungiant.");
      } else {
        setError("Neteisingas el. paštas arba slaptažodis.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div>
      {audience === "casual" && (
        <>
          <OAuthButtons />
          <div style={{ textAlign: "center", fontSize: 12, color: "#9ca3af", marginBottom: 16 }}>arba</div>
        </>
      )}
      <form onSubmit={handleSubmit}>
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
          El. paštas
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 mb-3 border border-gray-200 rounded-lg text-sm"
        />
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
          Slaptažodis
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-2 mb-2 border border-gray-200 rounded-lg text-sm"
        />

        <button
          type="button"
          onClick={onForgotPassword}
          style={{ fontSize: 12, color: "#383853", background: "none", border: 0, padding: 0, marginBottom: 16, cursor: "pointer" }}
        >
          Pamiršote slaptažodį?
        </button>

        {error && <div style={{ fontSize: 13, color: "#735DFF", marginBottom: 12 }}>{error}</div>}

        <button
          type="submit"
          disabled={submitting}
          className="w-full px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark disabled:opacity-60"
        >
          {submitting ? "Jungiamasi..." : "Prisijungti"}
        </button>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 13, color: "#383853" }}>
          Neturite paskyros?{" "}
          <button type="button" onClick={onGoToSignup} style={{ color: "#735DFF", fontWeight: 600, background: "none", border: 0, cursor: "pointer" }}>
            Registruotis
          </button>
        </div>
      </form>
    </div>
  );
}
